import React from 'react';
import { Phone, ShieldAlert, ArrowRight, Star } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 md:py-24 px-4 sm:px-6 lg:px-8 bg-slate-50 border-t border-slate-200 text-center" data-id="element-874">
      <div className="max-w-3xl mx-auto" data-id="element-875">
        <div className="inline-flex items-center gap-2 bg-emergencyBrand-redLight text-emergencyBrand-red px-4 py-2 rounded-full text-sm font-semibold mb-6 border border-emergencyBrand-redBorder" data-id="element-876">
          <ShieldAlert className="w-4 h-4" data-id="element-877" />
          <span data-id="element-878">Don't Wait. Damage Can Spread.</span>
        </div>
        <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-5 tracking-tight leading-tight" data-id="element-879">
          <span className="text-emergencyBrand-red" data-id="element-880">Broken Windshield</span> or
          Car Window Today?
        </h2>
        <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-881">
          Do not wait for urgent auto glass damage to get worse. Call Kosin's
          Glass now or request an urgent quote and get help confirming the
          safest, fastest available repair or replacement option.
        </p>
        {/* Trust line above buttons */}
        <div className="inline-flex items-center gap-2 mb-8" data-id="element-882">
          <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-883">
            {[0, 1, 2, 3, 4].map(i => <Star key={i} className="w-4 h-4 text-amber-500 fill-amber-500" data-id="element-884" />)}
          </span>
          <span className="sr-only" data-id="element-885">5-star service.</span>
          <span className="text-sm font-semibold text-slate-700" data-id="element-886">
            Drivers across Southeast Michigan call Kosin's Glass when broken
            vehicle glass needs urgent attention.
          </span>
        </div>
        <div className="flex flex-col sm:flex-row justify-center gap-3 mb-6" data-id="element-887">
          <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-emergencyBrand-red hover:bg-emergencyBrand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-888">
            <Phone className="w-5 h-5" data-id="element-889" />
            Call 517-545-7772 Now
          </a>
          <a href="#quote-form" className="inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-100 text-slate-900 border border-slate-300 px-7 py-4 rounded-lg font-bold text-base transition-colors" data-id="element-890">
            Request Urgent Auto Glass Quote
            <ArrowRight className="w-4 h-4" data-id="element-891" />
          </a>
        </div>
        <p className="text-sm text-slate-500" data-id="element-892">
          Same-day openings may be available depending on glass availability and
          schedule.
        </p>
      </div>
    </section>;
}